// extracted by mini-css-extract-plugin
export const root = "index-modules--root--3-Dr6";
export const closeButton = "index-modules--closeButton--2aJr4";